import Vue from "vue";
import Vuex from "vuex";

import {
  fetchTopic,
  fetchEvent,
  fetchRead,
  fetchReadPlace,
  fetchNews,
  fetchReadDetail,
} from "@/api/base";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //
    read: [],
    readPlace: [],
    readTotal: [],
    readPlaceTotal: [],
    //
    menu: [],
    active: {
      label: "",
      path: "",
      meta: {
        showhead: false,
        pageTitle: "",
        headbg: "",
      },
    },
    topic: {},
    event: {},
    news: {},
    homeEvent: [],
    homeNews: [],
    readDetail: {},
    tips: null,
  },
  mutations: {
    SET_READDETAIL(state, { readDetail }) {
      state.readDetail = readDetail;
    },
    SET_MENU(state, { menu }) {
      state.menu = menu;
    },
    SET_TIPS(state, { tips }) {
      state.tips = tips;
    },
    SET_ACTIVE(state, { active }) {
      state.active = active;
    },
    SET_HOMEEVENT(state, { homeEvent }) {
      state.homeEvent = homeEvent.slice(0, 3);
    },
    SET_HOMENEWS(state, { homeNews }) {
      state.homeNews = homeNews.slice(0, 3);
    },
    SET_TOPIC(state, { topic }) {
      state.topic = topic;
    },
    SET_EVENT(state, { event }) {
      state.event = event;
    },
    SET_READ_TOTAL(state, { read }) {
      state.readTotal = read;
    },
    SET_READPLACE_TOTAL(state, { readPlace }) {
      state.readPlaceTotal = readPlace;
    },
    SET_NEWS(state, { news }) {
      state.news = news;
    },
    set_read(state, { data }) {
      state.read = data;
    },
    set_read_place(state, { data }) {
      state.readPlace = data;
    },
  },
  actions: {
    readMore({ commit, state }, { page, size }) {
      return new Promise((resolve) => {
        let data = state.readTotal.slice(0, page * size);
        commit("set_read", { data });
        resolve(data);
      });
    },
    readPlaceMore({ commit, state }, { page, size }) {
      return new Promise((resolve) => {
        let data = state.readPlaceTotal.slice(0, page * size);
        commit("set_read_place", { data });
        resolve(data);
      });
    },
    GET_HOMEEVENT: ({ commit }, { params, submenu }) => {
      console.log("submenu", submenu);
      console.log("params", params);
      return new Promise((resolve) => {
        if (submenu) {
          fetchEvent(params, 'event',true).then((res) => {
            commit("SET_HOMEEVENT", { homeEvent: res.data });
            resolve();
          });
        } else {
          fetchEvent(params, 'event',false).then((res) => {
            commit("SET_HOMEEVENT", { homeEvent: res.data });
            resolve();
          });
        }
      });
    },
    GET_HOMENEWS: ({ commit }, params) => {
      return new Promise((resolve) => {
        fetchNews(params).then((res) => {
          commit("SET_HOMENEWS", { homeNews: res.data });
          resolve();
        });
      });
    },
    FETCH_READDETAIL: ({ commit }, params) => {
      return new Promise((resolve) => {
        fetchReadDetail(params).then((res) => {
          res.data.photos.map((x) => {
            x.src = x.photo;
            x.w = 1200;
            x.h = 800;
            x.msrc = x.photo;
          });
          commit("SET_READDETAIL", { readDetail: res.data });
          resolve();
        });
      });
    },
    FETCH_TOPIC: ({ commit }, params) => {
      return new Promise((resolve) => {
        fetchTopic(params).then((res) => {
          commit("SET_TOPIC", { topic: res.data });
          // let menu = res.data.menu['main-menu'].filter(x => x.path!='read')
          let menu = res.data.menu["main-menu"];
          let tips = res.data.tips;
          commit("SET_MENU", { menu });
          commit("SET_TIPS", { tips });
          resolve();
        });
      });
    },
    FETCH_EVENT: ({ commit }, { param, submenu }) => {
      return new Promise((resolve) => {
        fetchEvent(param, submenu).then((res) => {
          // console.log('data',res.data)
          // res.data[res.data.length-1]['file']?'':res.data.pop()
          commit("SET_EVENT", { event: res.data });
          resolve();
        });
      });
    },
    FETCH_READ: ({ commit }, params) => {
      return new Promise((resolve) => {
        fetchRead(params).then((res) => {
          commit("SET_READ_TOTAL", { read: res.data });
          resolve();
        });
      });
    },
    FETCH_READPLACE: ({ commit }, params) => {
      return new Promise((resolve) => {
        fetchReadPlace(params).then((res) => {
          commit("SET_READPLACE_TOTAL", { readPlace: res.data });
          resolve();
        });
      });
    },
    FETCH_NEWS: ({ commit }, params) => {
      return new Promise((resolve) => {
        fetchNews(params).then((res) => {
          commit("SET_NEWS", { news: res.data });
          resolve();
        });
      });
    },
  },
  modules: {},
});
